import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  return {
    carousel: searchParams.get('carousel') || '1',
    user: searchParams.get('user') || '75768268519',
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 500,
    speedSlow: searchParams.get('speedSlow')
      ? parseInt(searchParams.get('speedSlow') || '')
      : 500,
    speedFast: searchParams.get('speedFast')
      ? parseInt(searchParams.get('speedFast') || '')
      : 50,
    period: searchParams.get('period')
      ? parseInt(searchParams.get('period') || '')
      : 600,
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 50000,
    startFrom: parseInt(searchParams.get('startFrom') || '') || 4,
    bg: searchParams.get('bg') || null,
    bgColor: searchParams.get('bgColor') || 'rgba(0, 0, 0, 0)',
    scrollSpeed: searchParams.get('scrollSpeed')
      ? Number(searchParams.get('scrollSpeed'))
      : 3000,
    scrollDelay: searchParams.get('scrollDelay')
      ? Number(searchParams.get('scrollDelay'))
      : 2000,
    title: searchParams.get('title'),
    socials: searchParams.get('socials'),
    phoneNumber,
    // scaling
    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || 20,
    authorFontSize: searchParams.get('authorFontSize') || 20,
    msgFontSize: searchParams.get('msgFontSize') || 30,
    opacityBg: searchParams.get('opacityBg') || 0.7,

    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    qrTitle1: searchParams.get('qrTitle1'),
    qrTitle2: searchParams.get('qrTitle2'),

    paddingQR: searchParams.get('paddingQR') || '1.4',
  };
};
